<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h3>All candidates</h3>
      </v-col>
      <v-col cols="12">

      </v-col>
    </v-row>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>Edit {{ selectedCandidate.option }}</v-card-title>
        <v-card-text>
          <v-form>
            <v-col cols="12" md="4">
              <v-file-input
                  outlined
                  :rules="notEmpty"
                  dense
                  accept="image/*"
                  label="Upload your passport sized photo"
                  @change="onPassportSelected"
              ></v-file-input>
            </v-col>
            <v-btn @click="updateCandidate">Update</v-btn>
          </v-form>
        </v-card-text>
      </v-card>

    </v-dialog>
    <v-row>
      <v-col cols="12">
        <table-widget title="All Candidates" :headers="headers" :table-row-data="candidates" @editItem="viewCandidate"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableWidget from "@/components/widgets/tables/TableWidget";
import {getRequest} from "@/api/apirepository";
import httpClient from "@/api/api";
import {Cropper} from 'vue-advanced-cropper';
// Add the following line to import the cropper styles
import 'vue-advanced-cropper/dist/style.css';

export default {
  name: "Candidates",
  components: {TableWidget,Cropper},
  data() {
    return {
      dialog: false,
      notEmpty: [
        v => !!v || 'Field is required',
      ],
      candidates: [],
      selectedCandidate: [],
      headers: [
        {text: 'Image', value: 'image'},
        {text: 'Name', value: 'option'},
        {text: 'Actions', value: 'action'}
      ],
      documentHolder: new Form({
        passport: "",
      })
    }
  },
  methods: {
    change({coordinates, canvas}) {
      console.log(coordinates, canvas)
    },
    onPassportSelected(e) {
      this.documentHolder.passport = e;
    },
    viewCandidate(e) {
      this.dialog = true;
      this.selectedCandidate = e.item
    },
    getCandidates() {
      getRequest('pollOptions').then(({data}) => {
        this.candidates = data.map(item => {
          return {
            ...item,
            'image':  item.image
          }
        });
      }).catch(e => {
        console.log(e)
      })
    },
    updateCandidate() {
      swal
          .fire({
            title: "Change Profile",
            text: "this will replace the existing file",
            icon: "warning",
            showCancelButton: true,
            showDenyButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Proceed!",
          })
          .then((result) => {
            if (result.isConfirmed) {
              let dataForm = new FormData();
              dataForm.append('passport', this.documentHolder.passport);
              dataForm.append('candId', this.selectedCandidate.id);
              const config = {
                headers: {
                  'content-type': 'multipart/form-data'
                }
              }
              httpClient.post('update-candidate', dataForm, config).then(res => {
                this.loading = false;
                swal.fire('success', '', 'success');
                // this.$router.push('/')
                location.reload();
              }).catch(e => {
                this.loading = false;
                swal.fire('Error', 'Error occurred retry', 'error')
              })
            } else if (result.isDenied) {
              // swal.fire('Changes are saved to browser', '', 'info')
            }
          })
          .catch((e) => {
            console.log(e);
          });
    }
  },
  created() {
    this.getCandidates()
  }
}
</script>

<style scoped>

</style>